import base from "./base";

//全production環境共通の設定
const conf = Object.assign({}, base, {
  ENV: "production",
  LOG_ENDPOINT_DOMAIN: "api-ai.comici.jp",
  LOG_TRACKING_ID: "hv9d4fgMJUsDvWm2",
  WAIT_AND_FREE_RECOVERY: 23 * 60 * 60, //23時間
});

export default conf;
